import { render, staticRenderFns } from "./TheAlgoliaSearchBar.vue?vue&type=template&id=83070af4&scoped=true&"
import script from "./TheAlgoliaSearchBar.vue?vue&type=script&lang=js&"
export * from "./TheAlgoliaSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./TheAlgoliaSearchBar.vue?vue&type=style&index=0&id=83070af4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83070af4",
  null
  
)

export default component.exports